import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { IGetAllDiarioObrasAtividadesUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_atividades_use_case";
import { IGetAllDiarioObrasParalisacoesUseCase } from "../../../presentation/useCases/read/get_all_diario_obras_paralisacoes_use_case";
import { DiarioObrasAtividadesFilter } from "../../models/diario_obras_atividades_filter";
import { DiarioObrasAtividadesLista } from "../../models/diario_obras_atividades_lista";
import { DiarioObrasParalisacoesFilter } from "../../models/diario_obras_paralisacoes_filter";
import { DiarioObrasParalisacoesLista } from "../../models/diario_obras_paralisacoes_lista";
import { IDiarioObraRepository } from "../../repositories/diario_obra_repository";


// GetAllDiarioObrasParalisacoesServicoUseCase


export class GetAllDiarioObrasParalisacoesServicoUseCase
  extends BasePaginatedUseCase<DiarioObrasParalisacoesLista>
  implements IGetAllDiarioObrasParalisacoesUseCase {
  constructor(private readonly repository: IDiarioObraRepository) {
    super();
  }

  async getAllListagemDiariosObrasParalisacoes(
    filter: DiarioObrasParalisacoesFilter,
    page: number,
    rowsPerPage: number,
  ): Promise<void> {
    if (filter.IdDiarioObras === undefined) throw new Error('Id de diario de obra inválido!');

    const response = await this.repository
      .getAllListagemDiariosObrasParalisacoes(
        filter,
        page,
        rowsPerPage,
      );
    this._items = response.items;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
  }
}
